import React from 'react';

interface BadgeProps {
  variant?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'error';
  children: React.ReactNode;
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}

const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  children,
  className = '',
  color,
  style,
}) => {
  const baseClasses = 'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium';

  const variantClasses = {
    default: 'bg-gray-200 text-gray-900 dark:bg-gray-600 dark:text-white',
    primary: 'bg-blue-200 text-blue-900 dark:bg-blue-600 dark:text-white',
    secondary: 'bg-purple-200 text-purple-900 dark:bg-purple-600 dark:text-white',
    success: 'bg-green-200 text-green-900 dark:bg-green-600 dark:text-white',
    warning: 'bg-amber-200 text-amber-900 dark:bg-amber-600 dark:text-white',
    danger: 'bg-red-200 text-red-900 dark:bg-red-600 dark:text-white',
    info: 'bg-blue-100 text-blue-800 dark:bg-blue-800 dark:text-blue-100',
    error: 'bg-red-200 text-red-900 dark:bg-red-600 dark:text-white',
  };

  const getTextColor = (bgColor: string): string => {
    const hex = bgColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#1F2937' : '#FFFFFF';
  };

  if (color) {
    const textColor = getTextColor(color);
    return (
      <span
        className={`${baseClasses} ${className}`}
        style={{
          backgroundColor: color,
          color: textColor,
          ...style
        }}
      >
        {children}
      </span>
    );
  }

  return (
    <span className={`${baseClasses} ${variantClasses[variant]} ${className}`} style={style}>
      {children}
    </span>
  );
};

export { Badge };
export default Badge;